export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    id: 'faq-1',
    question: '福利视频在线是否真的完全免费？',
    answer: '是的，福利视频在线平台上的所有视频内容均完全免费观看，无需付费订阅或充值。我们通过广告收入维持平台运营，致力于为广大用户提供优质的免费视频观看体验。',
  },
  {
    id: 'faq-2',
    question: '观看视频需要注册账号吗？',
    answer: '不需要。福利视频在线采用即点即看模式，无需注册或登录即可直接观看所有视频内容。我们简化了观看流程，让用户体验更加便捷流畅。',
  },
  {
    id: 'faq-3',
    question: '支持哪些设备观看？',
    answer: '福利视频在线全面支持PC电脑、平板、手机等多种设备。平台采用响应式设计技术，能够自动适配不同屏幕尺寸，确保在任何设备上都能获得最佳的观看体验。',
  },
  {
    id: 'faq-4',
    question: '视频画质如何？有高清选项吗？',
    answer: '平台提供标清、高清和超清等多种画质选项，用户可以根据自身网络状况和设备性能自由选择。大部分热门视频均支持1080P全高清画质播放。',
  },
  {
    id: 'faq-5',
    question: '如何搜索我想看的视频？',
    answer: '您可以通过首页的搜索框输入关键词进行搜索，也可以通过顶部的分类导航浏览不同类别的视频内容。平台支持按影片名称、演员、类型等多种方式进行检索。',
  },
  {
    id: 'faq-6',
    question: '视频加载慢或卡顿怎么办？',
    answer: '视频播放卡顿可能与您的网络环境有关。建议检查网络连接状态，或尝试切换至较低画质以获得更流畅的播放体验。如问题持续存在，请刷新页面或更换浏览器尝试。',
  },
  {
    id: 'faq-7',
    question: '平台上的视频内容多久更新一次？',
    answer: '福利视频在线每日更新大量新鲜视频内容。热门影视、综艺节目通常会在首播后24小时内上线，短视频和自媒体内容则保持实时更新，确保用户随时能看到最新内容。',
  },
  {
    id: 'faq-8',
    question: '可以下载视频到本地观看吗？',
    answer: '福利视频在线是一个在线观看平台，目前暂不支持视频下载功能。我们提供流畅的在线播放体验，您随时随地只要有网络连接即可观看。',
  },
];